import React from 'react';

export function prevent(callback?: any) {
  return (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    callback?.(event);
  };
}
export function stop(callback: any) {
  return (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.stopPropagation();
    callback?.(event);
  };
}
